import debounce from 'lodash/debounce';
import { ResourceApi } from '../../../resource/Resource';
import {
  PortalResource,
  PortalResourceValidateNewName,
} from '../../../resource/PortalResource/types';

export const validatePath = debounce(async (name, callback) => {
  if (name === null || name === undefined || name === '') {
    callback(false);
    return;
  }

  try {
    const result = await ResourceApi.lookup<
      PortalResource,
      PortalResourceValidateNewName
    >('portal', 'validateNewName', {
      name,
    });
    callback(result.canUse);
  } catch {
    callback(false);
  }
}, 300);

export const createPortal = async (
  name: string,
  displayName: string,
  subscriptionId?: string
): Promise<boolean | string> => {
  try {
    await ResourceApi.create('portal', { name, displayName, subscriptionId });
    return true;
  } catch (error) {
    if (error.response && error.response.reason) {
      return error.response.reason;
    } else if (error.message) {
      return error.message;
    }
    throw error;
  }
};
